<template>
  <SelectList
    v-model="selectedValue"
    :clearable="clearable"
    :dense="dense"
    :disable="disable"
    :emit-value="emitValue"
    :filled="filled"
    :filter-method="filter"
    :hide-selected="hideSelected"
    :hint="hint"
    :input-debounce="300"
    :label="label"
    :multiple="multiple"
    :option-label="optionLabel"
    option-value="id"
    :options="options"
    :rules="rules"
    :stack-label="stackLabel"
    :use-chips="useChips"
  />
</template>

<script>
import {
  Magazine,
  Newspaper,
  Podcast,
  RadioStation,
  TvChannel,
  Website,
} from "shared/resources";

import SelectList from "src/components/common/SelectList.vue";

export default {
  name: "SourcesDropdown",
  components: {
    SelectList,
  },
  props: {
    modelValue: {
      type: [Number, String, Array, Object],
      default: null,
    },
    resource: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
    rules: {
      type: Array,
      default: () => [],
    },
    defaultValue: {
      type: [Object, Array],
      default: () => ({}),
    },
    clearable: {
      type: Boolean,
    },
    multiple: {
      type: Boolean,
    },
    useChips: {
      type: Boolean,
    },
    filled: {
      type: Boolean,
    },
    stackLabel: {
      type: Boolean,
    },
    emitSelectedOption: {
      type: Boolean,
    },
    hint: {
      type: String,
      default: "",
    },
    optionLabel: {
      type: String,
      default: "label",
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    hideSelected: {
      type: Boolean,
    },
    dense: {
      type: Boolean,
    },
    grayLabel: {
      type: Boolean,
    },
    includeInternationalPlus: {
      type: Boolean,
      defualt: false,
    },
    disable: {
      type: Boolean,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      options: [],
      resources: {
        website: Website,
        magazine: Magazine,
        newspaper: Newspaper,
        tvChannel: TvChannel,
        radioStation: RadioStation,
        podcast: Podcast,
      },
    };
  },
  computed: {
    emitValue() {
      return !this.emitSelectedOption;
    },
    selectedValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    isTvOrRadio() {
      return ["tvChannel", "radioStation"].includes(this.resource);
    },
  },
  watch: {
    defaultValue: {
      immediate: true,
      deep: true,
      handler() {
        if (this.defaultValue.id) {
          this.options = [this.defaultValue];
        }
      },
    },
  },
  methods: {
    async filter(query) {
      let result = [];

      if (query) {
        try {
          const filter = {
            ...this.params,
            label: { match: encodeURIComponent(query) },
          };

          filter.active = true;

          if (!this.includeInternationalPlus && this.resource === "website") {
            filter.origin = { not_eq: "aylien" };
          }

          const order = this.isTvOrRadio ? { id: "asc" } : { name: "asc" };

          result = (
            await this.resources[this.resource]
              .where(filter)
              .order(order)
              .per(20)
              .all()
          ).data;

          if (this.isTvOrRadio || this.grayLabel) {
            result = result.map((resource) => ({
              ...resource,
              itemStyle:
                resource.recorder || resource.filenamePattern
                  ? ""
                  : "color: gray",
            }));
          }
        } catch (error) {
          this.$error("Error Loading Sources", error);
        }
      }

      return result;
    },
  },
};
</script>
